import axios from 'axios'
const uri = 'gestion-usuarios/php/'

const get = (url) => {
	return axios.get(uri + url)
}

const post = (url, datos) => {
	return axios.post(uri + url, datos)
}

export default {
	buscar (filtro) {
		return post('buscar.php', filtro)
	},

	getGrupos () {
		return get('getGrupos.php')
	},

	get (idUsuario) {
		return get('getUsuario.php?ID=' + idUsuario)
	},

	getEmpresas () {
		return get('getEmpresas.php')
	},

	setUsuario (datos) {
		const form = _.clone(datos)
		form.fecha_expiracion_cuenta = (datos.fecha_expiracion_cuenta) ? Math.floor(datos.fecha_expiracion_cuenta.getTime() / 1000) : 0
		form.caduca_password = (datos.caduca_password) ? Math.floor(datos.caduca_password.getTime() / 1000) : 0
		form.fecha_nacimiento = (datos.fecha_nacimiento) ? Math.floor(datos.fecha_nacimiento.getTime() / 1000) : 0
		return post('setUsuario.php', form)
	},

	delOTP (ID) {
		const datos = {
			ID: ID
		}
		return post('delOTP.php', datos)
	},

	resetPassword (datos) {
		return post('resetPassword.php', datos)
	},

	crearLdap (ID, usuario) {
		const datos = {
			ID: ID,
			usuario: usuario
		}

		return post('nuevoLdap.php', datos)
	},

	eliminaLdap (ID) {
		const datos = {
			ID: ID
		}

		return post('eliminaLdap.php', datos)
	},

	setUnix (ID, datos) {
		const form = {
			ID: ID,
			datos: datos
		}
		return post('setUnix.php', form)
	},

	setSamba (ID, datos) {
		const form = {
			ID: ID,
			datos: datos
		}
		return post('setSamba.php', form)
	},

	getDominios () {
		return get('getDominios.php')
	},

	getEmails (ID) {
		const form = {
			ID: ID
		}

		return post('getEmails.php', form)
	},

	setEmails (ID, emails) {
		const form = {
			ID: ID,
			emails: emails
		}

		return post('setEmails.php', form)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-usuarios/vue/api.js